import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    CircularProgress, Tooltip, MenuItem, Select, Chip
} from '@mui/material';
import {AiOutlineFile, AiOutlineInfoCircle} from "react-icons/ai";
import "./СaseFilesDialog.css"

const CaseFilesDialog = ({open, onClose, caseId, users, isChatPopup = false, showOnlyInspectFiles = false, showOnlyMainFiles = false}) => {
    const [inspectFiles, setInspectFiles] = useState([]);
    const [allFiles, setAllFiles] = useState([]);
    const [certificateFiles, setCertificateFiles] = useState([]);
    const [mainFiles, setMainFiles] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [noFilesMessage, setNoFilesMessage] = useState('');
    const [selectedFileType, setSelectedFileType] = useState(isChatPopup ? 'allFiles' : showOnlyInspectFiles ? "certificateFiles" : "mainFiles");

    const findUserById = (userId) => {
        const user = users.find(user => user.id === userId)
        return `${user.firstName} ${user.lastName}`
    }

    const closePopup = () => {
        onClose()
        setSelectedFileType("")
    }


    const formatDate = (dateString) => {
        if (dateString === '0001-01-01T00:00:00') {
            return 'თარიღი არ მოიძებნა';
        }

        const date = new Date(dateString);
        if (isNaN(date)) {
            return 'თარიღი არ მოიძებნა';
        }

        return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
    };

    const handleFileTypeChange = (event) => {
        setSelectedFileType(event.target.value);
    };


    useEffect(() => {
        const fetchFiles = async () => {
            setIsLoading(true);
            setNoFilesMessage('');
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllCaseFileByCaseID?CaseId=${caseId}`);
                if (response.data.success && response.data.data.resultItems.length > 0) {
                    setInspectFiles(response.data.data.resultItems.filter(file => file.isInspectFile));
                    setAllFiles(response.data.data.resultItems);
                    setCertificateFiles(response.data.data.resultItems.filter(file => file.isSertificatFile));
                    setMainFiles(response.data.data.resultItems.filter(file => !file.isSertificatFile && !file.isInspectFile))
                    setNoFilesMessage('');
                } else {
                    setMainFiles([]);
                    setCertificateFiles([]);
                    setInspectFiles([]);
                    setNoFilesMessage('განაცხადს არ აქვს მიბული დოკუმენტები!');
                }
            } catch (error) {
                setNoFilesMessage('დაფიქსირდა შეცდომა, ცადეთ მოგვიანებით!');
            } finally {
                setIsLoading(false);
            }
        };

        if (open) {
            if (isChatPopup) {
                setSelectedFileType("allFiles")
            } else if (showOnlyInspectFiles) {
                setSelectedFileType("certificateFiles")
            } else {
                setSelectedFileType("mainFiles")
            }
            void fetchFiles();
        }
    }, [open, caseId]);

    return (
        <Dialog open={open} onClose={closePopup} fullWidth maxWidth={false} style={{width: '95%', margin: 'auto'}}>
            {!showOnlyMainFiles && (
                <>
                    <DialogTitle>განაცხადის დოკუმენტაცია</DialogTitle>
                    {!isChatPopup && (
                        <Select
                            value={selectedFileType}
                            onChange={handleFileTypeChange}
                            displayEmpty
                            inputProps={{'aria-label': 'Without label'}}
                            style={{marginBottom: 20, width: 400, marginLeft: 20}}
                        >
                            {!showOnlyInspectFiles && (
                                <MenuItem value="mainFiles">განაცხადის დოკუმენტები</MenuItem>
                            )}
                            <MenuItem value="inspectFiles">ინსპექტირების ოქმები</MenuItem>
                            <MenuItem value="certificateFiles">ინსპექტირების სერტიფიკატები</MenuItem>
                        </Select>
                    )}
                </>
            )}


            <DialogContent>
                {isLoading ? (
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 100}}>
                        <CircularProgress/>
                    </div>
                ) : (
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>დოკუმენტის სახელი</TableCell>
                                    <TableCell>დოკუმენტის შემქმნელი</TableCell>
                                    <TableCell>საჯარო</TableCell>
                                    {selectedFileType === 'certificateFiles' && (
                                        <>
                                            <TableCell>გაცემის თარიღი</TableCell>
                                            <TableCell>მოქმედების ვადა</TableCell>
                                            <TableCell>გამცემი ორგანო</TableCell>
                                        </>
                                    )}

                                    {selectedFileType === 'inspectFiles' && (
                                        <>
                                            <TableCell>განხორციელების თარიღი</TableCell>
                                            <TableCell>გადამოწმების თარიღი</TableCell>
                                            <TableCell>კრიტიკული შეუსაბამომებები</TableCell>
                                            <TableCell>არსებითი შეუსაბამომებები</TableCell>
                                            <TableCell>არაარსებითი შეუსაბამომებები</TableCell>
                                            <TableCell>ინსპექტირების ჩაუტარებლობა დარღვევა</TableCell>
                                            <TableCell>ფარული ექსპლუატაცია დარღვევა</TableCell>
                                            <TableCell>ინსპექტორები</TableCell>
                                        </>
                                    )}
                                    <TableCell>ნახვა</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(selectedFileType === 'mainFiles' ? mainFiles :
                                    selectedFileType === 'allFiles' ? allFiles :
                                        selectedFileType === 'certificateFiles' ? certificateFiles : inspectFiles).length > 0 ? (
                                    (selectedFileType === 'mainFiles' ? mainFiles :
                                        selectedFileType === 'allFiles' ? allFiles :
                                            selectedFileType === 'certificateFiles' ? certificateFiles : inspectFiles).map((file) => (
                                        <TableRow key={file.id}>
                                            <TableCell>{file.name}</TableCell>
                                            <TableCell>{file.fullname}</TableCell>
                                            <TableCell>{file.shared ? 'კი' : 'არა'}</TableCell>
                                            {selectedFileType === 'certificateFiles' && (
                                                <>
                                                    <TableCell>{formatDate(file.sertificatReleaseDate)}</TableCell>
                                                    <TableCell>{formatDate(file.inspectionSertificatValidityPeriodDate)}</TableCell>
                                                    <TableCell>{file.inspectionSertificatIssuingAgency}</TableCell>
                                                </>
                                            )}

                                            {selectedFileType === 'inspectFiles' && (
                                                <>
                                                    <TableCell>{formatDate(file.inspectionDocumentmplementation)}</TableCell>
                                                    <TableCell>{formatDate(file.inspectionDocumentCheckingDate)}</TableCell>
                                                    <TableCell>{file.inconsistenciesCritical}</TableCell>
                                                    <TableCell>{file.inconsistenciesSubstantial}</TableCell>
                                                    <TableCell>{file.inconsistenciesNonSubstantial}</TableCell>
                                                    <TableCell>{file.violationFailureToConductInspection !== 0 ? "კი" : "არა"}</TableCell>
                                                    <TableCell>{file.violationHiddenExploitation !== 0 ? "კი" : "არა"}</TableCell>
                                                    <TableCell>
                                                        <div style={{display: 'flex', flexWrap: 'wrap', gap: '10px'}}>
                                                            {file.expertIdsWhoWorking.map((id, index) => (
                                                                <Chip key={index} label={findUserById(id)}
                                                                      variant="outlined"/>
                                                            ))}
                                                        </div>
                                                    </TableCell>
                                                </>
                                            )}
                                            <TableCell>
                                                <Tooltip title={"დოკუმენტის ნახვა"}>
                                                    <div>
                                                        <a href={file.path} target="_blank" rel="noopener noreferrer"
                                                           style={{textDecoration: 'none'}}>
                                                            <AiOutlineFile size="24px" style={{
                                                                color: 'rgb(0, 123, 255)',
                                                                cursor: 'pointer'
                                                            }}/>
                                                        </a>
                                                    </div>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow className="files-dialog-no-found-row">
                                        <TableCell colSpan={25} className="files-dialog-no-found-cell">
                                            <div className="files-dialog-no-found-message">
                                                <AiOutlineInfoCircle className="files-dialog-no-found-icon"/>
                                                {noFilesMessage || 'არაფერი მოიძებნა!'}
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>

                        </Table>
                    </TableContainer>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={closePopup} color="primary">
                    დახურვა
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CaseFilesDialog;
